import React from "react";
import get from "lodash/get";
import {connect} from "react-redux";
import compose from "lodash/flowRight";
import {withRouter} from "react-router-dom";
import {Trans, withTranslation} from "@unibuddy/intl";
import styled from "styled-components";

import s from "../../../Register/components/Register.pcss";
import {PageTitle} from "../../../../components/PageTitle/PageTitle";
import PageHeader from "../../../Shared/components/PageHeader/PageHeader";
import {
    INTL_LOGIN_WITH_NEW_PASSWORD,
    INTL_PASSWORD_RESET,
    INTL_RESET_SUCCESSFUL,
} from "../../../../translations/passwordReset";
import {IntlNamespaces} from "../../../../translations/types";

const StyledLink = styled.a`
    color: var(--theme-primary);
    text-decoration: underline;

    &:hover,
    &:focus {
        color: var(--theme-primary);
    }
`;

const ResetPasswordComplete = (props) => {
    const redirectUrl = get(props.location, "state.redirectUrl", "") || "/auth/login";
    const {t} = props;
    /*
        We use an <a> rather than a <Link> here because react router
        treats fully qualified urls (including the domain) as if they
        are relative paths (which they are not!)
    */
    return (
        <>
            <PageTitle title={t(INTL_RESET_SUCCESSFUL.key, INTL_RESET_SUCCESSFUL.defaultValue)} />
            <div className="panel panel-default">
                <div className="panel-body">
                    <div className={s.registerPagePanelHeader}>
                        <PageHeader
                            title={t(INTL_PASSWORD_RESET.key, INTL_PASSWORD_RESET.defaultValue)}
                        />
                        <Trans t={t} i18nKey={INTL_LOGIN_WITH_NEW_PASSWORD.key}>
                            <span>
                                Your password has been reset. You may now&nbsp;
                                <StyledLink id="continue" href={redirectUrl}>
                                    login
                                </StyledLink>
                                &nbsp;with your new password.
                            </span>
                        </Trans>
                    </div>
                </div>
            </div>
        </>
    );
};

ResetPasswordComplete.propTypes = {};

export default compose(
    connect(),
    withRouter,
    withTranslation(IntlNamespaces.PASSWORD_RESET),
)(ResetPasswordComplete);
